(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-color-split-modal"] && !Shopify.designMode) return;
  try {
    (function() {

    function formatMoney(cents, format) {
      var amount = (cents / 100).toFixed(2);
      var parts  = amount.split('.');
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = dollars + '.' + parts[1];
      return (format || '${{amount}}')
        .replace('{{amount}}', formatted)
        .replace('{{amount_no_decimals}}', dollars)
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', parts[0]);
    }

    function initColorSplitModals() {
      // Scoped to .color-split-modal only — does NOT touch .quick-add-modal
      var modals = document.querySelectorAll('.color-split-modal');

      modals.forEach(function(modal) {
        if (modal.dataset.csmInitialized) return;

        var form         = modal.querySelector('.csm-product-form');
        var button       = modal.querySelector('[name="add"]');
        var variantInput = modal.querySelector('.color-split-modal__variant-input');
        var dataScript   = modal.querySelector('.csm-variants-data');

        if (!form || !button || !variantInput || !dataScript) return;

        modal.dataset.csmInitialized = 'true';

        // Body scroll lock
        var scrollObserver = new MutationObserver(function() {
          if (modal.open) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
          } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
          }
        });
        scrollObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });

        modal.addEventListener('close', function() {
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
        });

        var productData;
        try {
          productData = JSON.parse(dataScript.textContent);
        } catch (e) {
          console.error('[CSM] Failed to parse product data:', e);
          return;
        }

        var priceEl        = modal.querySelector('.color-split-modal__price');
        var comparePriceEl = modal.querySelector('.color-split-modal__compare-price');

        function norm(s) {
          return (s || '').trim().toLowerCase()
            .replace(/[''‚‛′‵]/g, "'");
        }

        var colorValue = (productData.colorValue || '').trim();

        // Find color option index
        var colorIdx = -1;
        productData.variants.some(function(v) {
          for (var i = 0; i < v.options.length; i++) {
            if (norm(v.options[i]) === norm(colorValue)) { colorIdx = i; return true; }
          }
          return false;
        });

        var colorOptName = (colorIdx !== -1 && productData.options[colorIdx])
          ? productData.options[colorIdx].trim()
          : (productData.colorOptionName || 'Color').trim();

        function variantExists(optionMap) {
          return productData.variants.some(function(variant) {
            for (var i = 0; i < productData.options.length; i++) {
              var optName = (productData.options[i] || '').trim();
              if (Object.prototype.hasOwnProperty.call(optionMap, optName)) {
                if (norm(variant.options[i]) !== norm(optionMap[optName])) return false;
              }
            }
            return true;
          });
        }

        function updateAvailability() {
          var currentSelections = {};
          form.querySelectorAll('input[type="radio"]:checked').forEach(function(input) {
            currentSelections[input.name.trim()] = input.value.trim();
          });

          form.querySelectorAll('input[type="radio"]').forEach(function(radio) {
            var hypothetical = Object.assign({}, currentSelections);
            hypothetical[radio.name.trim()]  = radio.value.trim();
            hypothetical[colorOptName]       = colorValue;

            var available = variantExists(hypothetical);
            var label = form.querySelector('label[for="' + radio.id + '"]');
            if (label) label.classList.toggle('is-unavailable', !available);
          });
        }

        function updateVariantId() {
          var selectedOptions = {};
          form.querySelectorAll('input[type="radio"]:checked').forEach(function(input) {
            selectedOptions[input.name.trim()] = input.value.trim();
          });

          var allExpected = Object.assign({}, selectedOptions);
          allExpected[colorOptName] = colorValue;

          var match = productData.variants.find(function(variant) {
            for (var i = 0; i < productData.options.length; i++) {
              var optName = (productData.options[i] || '').trim();
              if (Object.prototype.hasOwnProperty.call(allExpected, optName)) {
                if (norm(variant.options[i]) !== norm(allExpected[optName])) return false;
              }
            }
            return true;
          });

          if (match) {
            variantInput.value = match.id;
            button.disabled = false;
            button.classList.remove('is-unavailable');

            if (priceEl) {
              priceEl.innerHTML = formatMoney(match.price, productData.moneyFormat);
            }
            if (comparePriceEl) {
              if (match.compare_at_price && match.compare_at_price > match.price) {
                comparePriceEl.innerHTML = formatMoney(match.compare_at_price, productData.moneyFormat);
                comparePriceEl.style.display = '';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }
          } else {
            variantInput.value = '';
            button.disabled = true;
            button.classList.add('is-unavailable');
          }

          updateAvailability();
        }

        form.querySelectorAll('input[type="radio"]').forEach(function(input) {
          input.addEventListener('change', updateVariantId);
        });
        updateVariantId();

        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          updateVariantId();

          var variantId = variantInput.value;
          if (!variantId) {
            console.warn('[CSM] No variant ID — aborting add-to-cart.');
            return;
          }

          button.classList.add('csm-adding');
          button.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          })
          .then(function(response) {
            if (!response.ok) throw new Error('HTTP error! status: ' + response.status);
            return response.json();
          })
          .then(function() {
            button.classList.remove('csm-adding');
            button.classList.add('csm-added');

            // Open cart drawer on desktop only
            if (window.innerWidth >= 750) {
              openCartDrawer();
            }

            // Update cart count badge in the background without opening the drawer
            var cartItemsEl = document.querySelector('cart-items-component');
            var sectionId   = cartItemsEl ? cartItemsEl.dataset.sectionId : null;

            if (sectionId) {
              fetch('/?sections=' + encodeURIComponent(sectionId))
                .then(function(res) { return res.json(); })
                .then(function(sections) {
                  var html = sections[sectionId];
                  if (!html) return;

                  var parser   = new DOMParser();
                  var newDoc   = parser.parseFromString(html, 'text/html');
                  var existingDrawer = document.querySelector('cart-drawer-component');
                  var newDrawer      = newDoc.querySelector('cart-drawer-component');

                  if (existingDrawer && newDrawer) {
                    // Update drawer contents but do NOT open it
                    var existingInner = existingDrawer.querySelector('.cart-drawer__inner');
                    var newInner      = newDrawer.querySelector('.cart-drawer__inner');
                    if (existingInner && newInner) {
                      existingInner.innerHTML = newInner.innerHTML;
                    }

                    // Update cart icon count badge only
                    var existingTrigger = existingDrawer.querySelector('button[on\\:click="/open"]');
                    var newTrigger      = newDrawer.querySelector('button[on\\:click="/open"]');
                    if (existingTrigger && newTrigger) {
                      existingTrigger.innerHTML = newTrigger.innerHTML;
                      var newLabel = newTrigger.getAttribute('aria-label');
                      if (newLabel) existingTrigger.setAttribute('aria-label', newLabel);
                    }
                  }
                })
                .catch(function(err) { console.warn('[CSM] Section render failed:', err); });
            }
          })
          .then(function() {
            setTimeout(function() {
              if (modal) {
                modal.classList.add('color-split-modal-closing');
                setTimeout(function() {
                  modal.close();
                  modal.classList.remove('color-split-modal-closing');
                  button.classList.remove('csm-added');
                  button.disabled = false;
                }, 300);
              }
            }, 1200);
          })
          .catch(function(error) {
            console.error('[CSM] Error adding to cart:', error);
            button.classList.remove('csm-adding');
            button.classList.remove('csm-added');
            button.disabled = false;
            alert('Could not add to cart: ' + (error.message || 'Unknown error'));
          });

          return false;
        });
      });
    }

    function openCartDrawer() {
      setTimeout(function() {
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (!cartDrawer) return;
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          var trigger = cartDrawer.querySelector('button[on\\:click="/open"]');
          if (trigger) trigger.click();
        }
      }, 300);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initColorSplitModals);
    } else {
      initColorSplitModals();
    }

    var domObserver = new MutationObserver(function() { initColorSplitModals(); });
    domObserver.observe(document.body, { childList: true, subtree: true });

  })();
  } catch(e) { console.error(e); }
})();

})();
